import {Controller} from "stimulus";

export default class extends Controller {

    connect() {
        console.log("log from fee-controller");
    }

    add(e) {
        e.preventDefault();
        const form = e.target;
        const button = e.submitter || form.querySelector("button[type='submit'], button:not([type])");

        if (button) {
            button.disabled = true;
            button.textContent = "Adding...";
        }

        const formData = new FormData(form);

        fetch(form.action, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
                "Accept": "application/json"
            },
            body: formData
        }).then(response => {
            if (!response.ok) {
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    return response.json().then(data => { throw new Error(data.error || "Fee could not be added."); });
                }
                throw new Error("Fee could not be added.");
            }
            return response.json();
        }).then((data) => {
            this._appendFeeRow(data);
            this._showFlash("Fee successfully added.", "notice");
        }).catch((error) => {
            this._showFlash(error.message, "alert");
        }).finally(() => {
            if (button) {
                button.disabled = false;
                button.textContent = "Add";
            }
        });
    }

    build(e) {
        e.preventDefault();
        const button = e.target;
        button.disabled = true;
        button.textContent = "Charging...";

        let data = {
            fee_type: e.target.dataset.feeType,
            parent_klass: e.target.dataset.klass,
            charge: e.target.dataset.amount
        }
        let feeableId = '';
        if (document.getElementById('bl_license_application_id')) {
            feeableId = document.getElementById('bl_license_application_id').value
        }
        fetch(window.location.href
            .replace('/new', `/${feeableId}`)
            .replace('/edit', '') + '/fees/build', {
            method: 'POST',
            credentials: "same-origin",
            headers: {
                "X-CSRF-Token": document.getElementsByName('csrf-token')[0].content,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (!response.ok) {
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    return response.json().then(d => { throw new Error(d.error || "Fee could not be charged."); });
                }
                throw new Error("Fee could not be charged.");
            }
            return response.json();
        }).then((data) => {
                document.getElementById("checkoutMiniCartCartTotal").innerText = '$' + Number(data['amount_owed']).toFixed(2)
                document.getElementById("checkoutMiniCartCount").innerText = data['cart_item_count']
                document.getElementById("checkoutMiniCart").classList.add("cart-show");
                if (data.fee) {
                    this._appendFeeRow(data.fee);
                }
            })
            .catch((error) => {
                this._showFlash(error.message, "alert");
            })
            .finally(() => {
                button.disabled = false;
                button.textContent = "Charge";
            })
    }

    _appendFeeRow(fee) {
        const tbody = document.getElementById("fee-table-body");
        const container = document.getElementById("fee-table-container");

        if (container && container.classList.contains("hidden")) {
            container.classList.remove("hidden");
        }

        if (!tbody) return;

        const row = document.createElement("tr");

        const descTd = document.createElement("td");
        descTd.style.maxWidth = "fit-content";
        descTd.textContent = `${fee.created_at}: ${fee.fee_description}`;
        row.appendChild(descTd);

        const amountTd = document.createElement("td");
        if (fee.cartable) { amountTd.className = "alert"; }
        amountTd.textContent = `$${Number(fee.adjusted_amount).toFixed(2)}`;
        row.appendChild(amountTd);

        const paidTd = document.createElement("td");
        paidTd.textContent = `$${Number(fee.amount_already_paid).toFixed(2)}`;
        row.appendChild(paidTd);

        const actionTd = document.createElement("td");
        actionTd.className = "action-column hide-on-print";

        if (fee.cartable) {
            const chargeDiv = document.createElement("div");
            chargeDiv.className = "action-area-button py-1 m-1";
            const chargeLink = document.createElement("a");
            chargeLink.href = fee.charge_url;
            chargeLink.className = "inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md bg-purple-100 text-purple-700 hover:bg-purple-200 cursor-pointer";
            chargeLink.dataset.action = "miniCart#addItemFromDataset";
            chargeLink.dataset.id = fee.id;
            chargeLink.dataset.klass = "Fee";
            chargeLink.dataset.charge = fee.amount_owed;
            chargeLink.dataset.turbo = "false";
            chargeLink.textContent = "Charge";
            chargeDiv.appendChild(chargeLink);
            actionTd.appendChild(chargeDiv);

            if (fee.unpaid) {
                const cancelDiv = document.createElement("div");
                cancelDiv.className = "action-area-button py-1 m-1";
                const cancelLink = document.createElement("a");
                cancelLink.href = fee.cancel_url;
                cancelLink.className = "inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md bg-red-100 text-red-700 hover:bg-red-200 cursor-pointer";
                cancelLink.dataset.turboMethod = "delete";
                cancelLink.dataset.turboConfirm = "Are you sure?";
                cancelLink.textContent = "Cancel";
                cancelDiv.appendChild(cancelLink);
                actionTd.appendChild(cancelDiv);
            }
        } else {
            const txLink = document.createElement("a");
            txLink.href = fee.transactions_url;
            txLink.className = "transactions-link";
            txLink.textContent = "Transactions";
            actionTd.appendChild(txLink);
        }

        row.appendChild(actionTd);
        tbody.appendChild(row);
    }

    _showFlash(message, type) {
        const flashArea = document.querySelector("#flash-area");
        if (!flashArea) return;

        const isAlert = type === "alert";
        const cssBody = isAlert ? "text-rose-700 bg-rose-50" : "text-emerald-700 bg-emerald-50";
        const cssBar = isAlert ? "bg-rose-400" : "bg-emerald-400";

        const wrapper = document.createElement("div");
        wrapper.className = "fixed top-0 left-0 right-0 z-50 mb-4 rounded-lg shadow-sm";

        const bar = document.createElement("div");
        bar.className = `h-1 ${cssBar}`;
        wrapper.appendChild(bar);

        const body = document.createElement("div");
        body.className = `px-4 py-3 text-sm ${cssBody}`;
        const p = document.createElement("p");
        p.className = "mt-1 text-sm";
        p.textContent = message;
        body.appendChild(p);
        wrapper.appendChild(body);

        flashArea.textContent = "";
        flashArea.appendChild(wrapper);
        setTimeout(() => { flashArea.textContent = ""; }, 4500);
    }
}
